import { useMemo, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { Flex, MainHeadline, PageWrapper, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import useQueryPagination from 'hooks/useQueryPagination'
import {
  getDishes,
  getFoodDietaryTags,
  getFoodKitchens,
  getFoodMealWindows,
  getKitchenIngredients,
} from 'features/food/foodSlice'
import { DashboardTab } from './tabs/DashboardTab'
import { MenuPlannerTab } from './tabs/MenuPlannerTab'
import { DishesTab } from './tabs/DishesTab'
import { IngredientsTab } from './tabs/IngredientsTab'
import { ProductionTab } from './tabs/ProductionTab'
import { SuggestionsTab } from './tabs/SuggestionsTab'

const KITCHEN_TABS = ['Dashboard', 'Menu Planner', 'Dishes', 'Ingredients', 'Production', 'Suggestions']

export const Kitchen = () => {
  const [activeTab, setActiveTab] = useState('Dashboard')
  const [createDishOpen, setCreateDishOpen] = useState(false)
  const [menuPlannerToolbar, setMenuPlannerToolbar] = useState<React.ReactNode>(null)

  const params = useMemo(() => ({ page: 1, limit: 200 }), [])
  useQueryPagination({
    fetchFunctions: [
      getFoodKitchens,
      getFoodMealWindows,
      getFoodDietaryTags,
      getDishes,
      getKitchenIngredients,
    ],
    cleanUpFunctions: [],
    params,
  })

  const handleTabChange = (tab: string) => {
    setActiveTab(tab)
    if (tab !== 'Menu Planner') setMenuPlannerToolbar(null)
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <MainHeadline>Kitchen</MainHeadline>
        </Flex>
        <Flex between alignEnd mb='16' width='100%' wrap gap='1rem'>
          <TabsContainer>
            {KITCHEN_TABS.map((tab) => (
              <Tabs key={tab} active={activeTab === tab} onClick={() => handleTabChange(tab)}>
                {tab}
              </Tabs>
            ))}
          </TabsContainer>
          {activeTab === 'Menu Planner' && menuPlannerToolbar}
          {activeTab === 'Dishes' && (
            <Button variant='primary' onClick={() => setCreateDishOpen(true)}>
              New Dish
            </Button>
          )}
        </Flex>
        {activeTab === 'Dashboard' && <DashboardTab />}
        {activeTab === 'Menu Planner' && (
          <MenuPlannerTab onToolbarChange={setMenuPlannerToolbar} />
        )}
        {activeTab === 'Dishes' && (
          <DishesTab createOpen={createDishOpen} setCreateOpen={setCreateDishOpen} />
        )}
        {activeTab === 'Ingredients' && <IngredientsTab />}
        {activeTab === 'Production' && <ProductionTab />}
        {activeTab === 'Suggestions' && <SuggestionsTab />}
      </PageWrapper>
    </>
  )
}
